// Vercel Web Analytics records the full page URL. Some Haastia links carry
// secrets: booking-manage tokens in the path, and reset codes, email-change
// tokens, Stripe session ids and email addresses in the query string. Strip
// them before a page view leaves the browser.

const SECRET_PATHS = [
  { pattern: /^\/bookings\/manage\/[^/]+/i, replacement: '/bookings/manage/[token]' },
];

// Campaign tags are the only query parameters worth keeping.
const isCampaignParam = (key) => key.toLowerCase().startsWith('utm_');

export const redactAnalyticsUrl = (rawUrl) => {
  const url = new URL(rawUrl, window.location.origin);

  SECRET_PATHS.forEach(({ pattern, replacement }) => {
    url.pathname = url.pathname.replace(pattern, replacement);
  });

  const kept = new URLSearchParams();
  url.searchParams.forEach((value, key) => {
    if (isCampaignParam(key)) kept.append(key, value);
  });
  url.search = kept.toString();
  url.hash = '';

  return url.toString();
};

export const redactAnalyticsEvent = (event) => {
  try {
    return { ...event, url: redactAnalyticsUrl(event.url) };
  } catch {
    // If the URL can't be parsed we can't prove it's clean, so don't send it.
    return null;
  }
};
